<template>
    <div>
        <div class="row">
            <div class="col mt-lg-4">
                <h3>3. {{ $t('pax.suggestions_pax') }}</h3>
            </div>
        </div>
        <div v-if="processing">
            <LoadingSpinner class="col-12" />
        </div>

        <div v-else class="mt-lg-4">
            <div class="stallionGrade" v-for="stallion in stallions_suggestion" :key="stallion.horse_id" :class="callColorGrade(stallion.horse_id)">
                <div class="row no-gutters align-items-center" @click="showCompatibilite">
                    <div class="col-5">
                        <div class="stallionName">{{ stallion.horse_nom }}</div>
                    </div>
                    <div class="col-7 text-center">
                        <span class="bullet" v-for="critere in criteres" :class="getColorBullets(stallion.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <button class="btn btn-primary btn-next" @click="showCompatibilite">
                   {{ $t('pax.comparer_jusqua_3_etalons') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" />
                </button>
            </div>
        </div>

        <b-modal dialog-class="modal-pax" ref="modal" hide-footer id="paxModalSelection">
            <template v-slot:modal-title>
                {{ $t("pax.comparer_jusqua_3_etalons") }}
            </template>

            <div v-for="(stallion, index) in stallions_selected" class="form-group" :key="'stallion_'+index">
                <label for="season">{{ $t('pax.stallion') }} {{ index+1 }}</label>
                <e-select
                    v-model="stallions_selected[index]"
                    track-by="horse_id"
                    label="horse_nom"
                    :placeholder="$t('pax.selectionner_un_stallion')"
                    :options="stallions_selection_modal"
                    :allow-empty="false"
                    :show-labels="false"
                    :sortable="false"
                    :searchable="false"
                >
                    <template slot="singleLabel" slot-scope="{ option }">
                        <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
                            <div class="row no-gutters align-items-center" >
                                <div class="col-5">
                                    <div class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-7 text-center">
                                    <span class="bullet" v-for="critere in criteres" :class="getColorBullets(option.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="option" slot-scope="{ option }">
                        <div class="stallionGrade" :key="option.horse_id" :class="callColorGrade(option.horse_id)">
                            <div class="row no-gutters align-items-center" >
                                <div class="col-5">
                                    <div class="stallionName">{{ option.horse_nom }}</div>
                                </div>
                                <div class="col-7 text-center">
                                    <span class="bullet" v-for="critere in criteres" :class="getColorBullets(option.horse_id, recap, criteres, critere.criteres_id)[0]" :key="critere.criteres_id"><font-awesome-icon :icon="['fas', 'circle']"/></span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template slot="noOptions">{{ $t('global.list_empty') }}</template>
                </e-select>
            </div>

            <div class="text-center">
                <button class="btn btn-pax" @click="sendStallionsSelected">{{ $t('pax.comparer') }}</button>
            </div>
        </b-modal>
    </div>
</template>

<script type="text/javascript">
    import PaxMixin from "@/mixins/Pax.js"
    import _cloneDeep from 'lodash/cloneDeep';
    import Navigation from "@/mixins/Navigation.js"

    export default {
        name: 'PaxSuggestionResult',
        mixins: [PaxMixin, Navigation],
        props: {
            criteres: {
                type: Array,
                default: () => ( [] )
            },
            mare: {
                type: Object,
                default: () => ( null )
            }
        },
        data () {
            return {
                stallions_suggestion: [],
                stallions_selected: [null, null, null],
                stallions_selection_modal: [],
                recap: [],
                processing: false
            }
        },
        mounted() {
            this.init_component()
        },
        methods: {
            init_component() {
                this.calculSuggestion()
            },

            callColorGrade(stallion_id) {
                return this.colorGrade(stallion_id, this.recap, this.criteres)
            },

            async calculSuggestion() {
                this.processing = true

                const country = this.getConfig('country')

                const all_stallions = await this.getStallions()
                const stallions = all_stallions.filter(stallion => {
                    let countries = stallion.horse_pays
                    return countries.indexOf(parseInt(country.id)) > -1 && !stallion.categorie.includes('COLLECTION')
                })

                this.recap = await this.paxCalculCompatiblite(stallions, this.criteres)
                const notation = await this.getPaxColor(this.recap, this.criteres)
                const notation_sort = Object.entries(notation).sort((a,b) => b[1]-a[1]).slice(0, 5)

                this.stallions_suggestion = []
                notation_sort.forEach(stallion => {
                    this.stallions_suggestion.push(stallions.find(s => s.horse_id == stallion[0]))
                })
                this.processing = false
            },

            async showCompatibilite() {
                if(this.stallions_suggestion.length > 3) {
                    this.$refs.modal.show()
                    this.stallions_selection_modal = _cloneDeep(this.stallions_suggestion)
                    return false
                }
                this.$emit('update:step_label', "comparaison_V")
                this.$emit('update:stallions_comparaison', this.stallions_suggestion)
            },

            sendStallionsSelected() {
                this.$refs.modal.hide()
                this.$emit('update:step_label', "comparaison_V")
                this.$emit('update:stallions_comparaison', this.stallions_selected)
            },
        },
        components: {
            LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35')
        },
        watch: {
            'criteres': {
                deep: true,
                handler(val){
                    this.calculSuggestion()
                }
            },
            'stallions_selected': {
                deep: true,
                handler(val) {
                    let ids = []
                    val.forEach(stallion => {
                        if(stallion && stallion.horse_id) {
                            ids.push(stallion.horse_id)
                        }
                    })
                    this.stallions_selection_modal = this.stallions_suggestion.filter(stallion => !ids.includes(stallion.horse_id))
                }
            },
        }
    }

</script>